import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RulesOrder from './RulesOrder';
import { removeOrderedRule, reOrderRules } from 'redux/rules/RulesActions';

const mapStateToProps = ({ rules }) => ({
  orderedRules: rules.orderedRules
});

const mapDispatchToProps = dispatch => ({
  rulesActions: bindActionCreators({ removeOrderedRule, reOrderRules }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RulesOrder);



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/rulesPanel/comp/profileRulesManagement/comp/rulesOrder/RulesOrderConnector.js